export const REGISTRATION_ROUTE_NAME = '/registration';
export const PASSWORD_RECOVERY_ROUTE_NAME = '/password-recovery';
export const BASE_APP_PATH = '/';
export const PRODUCTS_PATH = '/products';
export const AUL_REG_PATH = '/registration/lku/aul';
export const LKU_CHOOSE_SIGN_REG_PATH = '/registration/lku/choose-sign';
export const USER_DATA_REG_PATH = '/registration/user-data';
export const NOT_AUTH_PAGES = [
    '/cryptoapitest',
    '/ca-check',
    '/registration/account-details',
    '/password-recovery/confirm',
    '/password-recovery/email'
];
